/**
 * @fileoverview SessionWarningModal.jsx - Modal de advertencia antes de cerrar sesión
 * 
 * Muestra un modal con:
 * - Mensaje de advertencia
 * - Contador regresivo
 * - Botón para extender sesión
 * - Botón para cerrar sesión ahora
 */

import React from 'react';

export default function SessionWarningModal({
  show,
  secondsRemaining,
  onExtendSession,
  onLogoutNow
}) {
  if (!show) return null;

  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 99999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-4)'
        }}
      >
        {/* Modal */}
        <div
          style={{
            backgroundColor: 'var(--white)',
            borderRadius: 'var(--radius-xl)',
            padding: 'var(--space-6)',
            maxWidth: '400px',
            width: '100%',
            boxShadow: 'var(--shadow-2xl)',
            textAlign: 'center',
            animation: 'slideIn 0.3s ease-out'
          }}
        >
          {/* Icono de advertencia */}
          <div
            style={{
              width: '80px',
              height: '80px',
              borderRadius: 'var(--radius-full)',
              backgroundColor: 'rgba(245, 158, 11, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto var(--space-4)'
            }}
          >
            <i 
              className="bi bi-clock-history"
              style={{
                fontSize: '40px',
                color: 'var(--feature-primary)'
              }}
            ></i>
          </div>

          {/* Título */}
          <h3
            style={{
              fontSize: 'var(--font-size-xl)',
              fontWeight: 'var(--font-weight-bold)',
              color: 'var(--gray-900)',
              marginBottom: 'var(--space-2)'
            }}
          >
            ¿Sigues ahí?
          </h3>

          {/* Mensaje */}
          <p
            style={{
              fontSize: 'var(--font-size-base)',
              color: 'var(--gray-600)',
              marginBottom: 'var(--space-4)',
              lineHeight: 1.5
            }}
          >
            Tu sesión se cerrará por inactividad en:
          </p>

          {/* Contador */}
          <div
            style={{
              fontSize: 'var(--font-size-4xl)',
              fontWeight: 'var(--font-weight-bold)',
              color: secondsRemaining <= 10 ? 'var(--color-danger)' : 'var(--feature-primary)',
              marginBottom: 'var(--space-4)',
              fontFamily: 'monospace',
              transition: 'color 0.3s ease'
            }}
          >
            {secondsRemaining}
            <span
              style={{
                fontSize: 'var(--font-size-lg)',
                fontWeight: 'var(--font-weight-normal)',
                marginLeft: 'var(--space-1)'
              }}
            >
              segundos
            </span>
          </div>

          {/* Botones */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--space-3)'
            }}
          >
            {/* Botón principal: Seguir conectado */}
            <button
              onClick={onExtendSession}
              style={{
                width: '100%',
                padding: 'var(--space-3) var(--space-4)',
                fontSize: 'var(--font-size-base)',
                fontWeight: 'var(--font-weight-semibold)',
                backgroundColor: 'var(--brand-primary)',
                color: 'var(--gray-900)',
                border: 'none',
                borderRadius: 'var(--radius-lg)',
                cursor: 'pointer',
                transition: 'var(--transition-base)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'var(--space-2)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-primary-hover)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-primary)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <i className="bi bi-check-circle-fill"></i>
              Seguir conectado
            </button>

            {/* Botón secundario: Cerrar sesión */}
            <button
              onClick={onLogoutNow}
              style={{
                width: '100%',
                padding: 'var(--space-3) var(--space-4)',
                fontSize: 'var(--font-size-base)',
                fontWeight: 'var(--font-weight-medium)',
                backgroundColor: 'transparent',
                color: 'var(--gray-600)',
                border: `1px solid var(--gray-300)`,
                borderRadius: 'var(--radius-lg)',
                cursor: 'pointer',
                transition: 'var(--transition-base)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 'var(--space-2)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--gray-100)';
                e.currentTarget.style.borderColor = 'var(--gray-400)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = 'var(--gray-300)';
              }}
            >
              <i className="bi bi-box-arrow-right"></i>
              Cerrar sesión ahora
            </button>
          </div>
        </div>
      </div>

      {/* Estilos de animación */}
      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(-10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
      `}</style>
    </>
  );
}